import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setKarigarProcessDeleteIndex } from "./karigarSlice";
import FormSelectionField from "../../components/formFields/FormSelectionField";

const KarigarProcessArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const KarigarProcessDeleteIndex = useAppSelector(
    (state) => state.karigar.KarigarProcessDeleteIndex,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ProcessList = useAppSelector((state) => state.Process.ProcessList);
  const handleDeleteAction = React.useCallback(
    (index: number) => {
      if (index > -1) {
        fieldArrayRenderProps.onRemove({ index: index });
      }
      dispatch(closeDialog());
      dispatch(setKarigarProcessDeleteIndex(-1));
    },
    [fieldArrayRenderProps, dispatch],
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        process_id: null,
        rate: null,
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(setKarigarProcessDeleteIndex(index));
    dispatch(openDialog("karigarprocessDeleteDialog"));
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {/* {fieldArrayRenderProps?.value?.length <= 0 ? pushElementInarray() : null} */}
      {dialogName === "karigarprocessDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Karigar Process Data"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(KarigarProcessDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map(
          (karigar_process: any, index: number) => (
            <GridLayoutItem key={index}>
              <Card className="fieldarray-card">
                <GridLayout
                  style={{ marginRight: 45 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[{ width: "40%" }, { width: "40%" }, { width: "10%" }]}
                >
                  <GridLayoutItem>
                    <Field
                      name={`${fieldArrayRenderProps.name}.${index}.process_id`}
                      label="Process"
                      placeholder="Select Process"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={ProcessList?.filter(
                        (p: any) =>
                          !fieldArrayRenderProps.value
                            ?.map((item: any) => item?.process_id)
                            ?.includes(p.ID) ||
                          p.ID ===
                            fieldArrayRenderProps.value[index]?.process_id,
                      )?.map((process: any) => {
                        return {
                          value: process.ID,
                          label: process.process_name,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`${fieldArrayRenderProps.name}.${index}.rate`}
                      label="Rate"
                      placeholder="i.e. 100"
                      type="number"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      marginTop: 42,
                    }}
                  >
                    <Button
                      // style={{ padding: 8, marginLeft: 0 }}
                      onClick={() => handleOpenDeleteDialog(index)}
                      // disabled={fieldArrayRenderProps.value.length === 1}
                      fillMode={"solid"}
                      themeColor={"error"}
                      type="button"
                      size={"small"}
                    >
                      Delete
                    </Button>
                  </GridLayoutItem>
                </GridLayout>
              </Card>
            </GridLayoutItem>
          ),
        )}
      <GridLayoutItem style={{ marginBottom: 10, textAlign: "left" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Karigar Process
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default KarigarProcessArray;
